import { render, staticRenderFns } from "./UpsertResource.vue?vue&type=template&id=0882c19f&lang=pug&"
import script from "./UpsertResource.vue?vue&type=script&lang=js&"
export * from "./UpsertResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports